module.exports = __webpack_public_path__ + "fonts/CalibreMediumItalic.7e9ed3a0.woff";